/**
 * Sidebar navigation: selected key and navigate by URL only. No Redux.
 * Use this for sidebar active tab and navigation; resets/other app state stay in tools or callers.
 */
import { useLocation, useNavigate } from "react-router-dom";
import { NAVIGATION_PAGE } from "../constants/metaData";
import {
  getNavKeyFromPath,
  getRouteByNavKey,
  NAV_LOCATION_STATE,
} from "../../routes/routeConfig";

function getNavRefreshLocationState(navKey) {
  switch (navKey) {
    case NAVIGATION_PAGE.home:
      return { [NAV_LOCATION_STATE.forceRefreshWorkingDocuments]: true };
    default:
      return null;
  }
}

export function useSidebarNav() {
  const location = useLocation();
  const navigate = useNavigate();

  const selectedKey = getNavKeyFromPath(location.pathname || "", location.state);

  const navigateToNavKey = (navKey, { refresh = false } = {}) => {
    const route = getRouteByNavKey(navKey);
    if (!route) return;

    if (!refresh) {
      navigate(route);
      return;
    }

    const refreshState = getNavRefreshLocationState(navKey);
    navigate(route, refreshState ? { state: refreshState } : undefined);
  };

  return { selectedKey, navigateToNavKey };
}
